import { cn } from "@ui/lib";
import Image from "next/image";

export function Logo({
	withLabel = true,
	className,
}: {
	className?: string;
	withLabel?: boolean;
}) {
	return (
		<span
			className={cn(
				"flex items-center font-semibold text-foreground leading-none justify-center my-4",
				className,
			)}
		>
			<Image className="block md:hidden" src="/images/s-logo.png" alt="Swiftia S logo" width={40} height={40} />
			{withLabel && (
				<span className="hidden text-base sm:text-lg md:block" style={{
					marginBottom: "-14px",
					color: "#ab47ff", 
					marginLeft: "-5px",
				}}>
					<Image src="/images/logo.png" alt="Swiftia S logo" width={100} height={100} />
				</span>
			)}
		</span>
	);
}
